import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const TitleContainer = styled.div<{ isFiltersOpen: boolean }>`
  padding-top: 24px;
  @media ${device.mobileL} {
    padding-top: 48px;
  }
  @media ${device.laptop} {
    display: flex;
    justify-content: flex-start;
    padding-top: 72px;
    margin-left: 137px;
    max-width: 672px;
  }
  @media ${device.laptopMd} {
    max-width: initial;
    margin-left: 158px;
    margin-left: ${({ isFiltersOpen }) => (isFiltersOpen ? '46px' : '158px')};
    max-width: ${({ isFiltersOpen }) => (isFiltersOpen ? '761px' : '865px')};
  }
`;

export const TitleWrapper = styled.div``;

export const PageTitle = styled.h4`
  color: ${COLORS.grey80};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
  padding-bottom: 4px;
`;

export const DagTitle = styled.h1`
  font-family: Audi Type Extended;
  color: ${COLORS.grey80};
  font-size: 28px;
  line-height: 44px;
  letter-spacing: 0.008px;
  /* font-weight: 700; */
  margin-top: 4px;
  margin-bottom: 12px;
  @media ${device.tablet} {
    margin-bottom: 16px;
  }
  @media ${device.laptop} {
    font-size: 40px;
    line-height: 60px;
  }
`;

export const HeaderDescription = styled.div`
  max-width: 570px;
  @media ${device.laptop} {
    max-width: 953px;
  }
`;
